export default __webpack_public_path__ + "13bb611c610ea1dd96ae089f05c922d1.svg";